import axios from 'axios'

class EcommerceOrdersQueries {
    fetchOrders(queryString = '') {
        const url = `/orders/orders${queryString ? (queryString.startsWith('?') ? queryString : `?${queryString}`) : ''}`
        return axios.get(url)
    }

    fetchOrder(orderId) {
        return axios.get(`/orders/orders/${orderId}`)
    }

    fetchOrderStatuses() {
        return axios.get('/orders/orders/dicts/statuses')
    }

    fetchCountries() {
        return axios.get('/geolocalizations/geolocalizations/dicts/countries?isShippingToAllowed=true')
    }

    fetchPrinters() {
        return axios.get('/print-manager/dicts/printers')
    }

    updateOrder(orderData) {
        return axios.patch(`/orders/orders-collector/${orderData.id}`, orderData)
    }

    addComment(commentData) {
        return axios.post('/orders/order-comments', commentData)
    }

    updateDelivery(deliveryId, payload) {
        return axios.patch(`/deliveries/delivery/${deliveryId}`, payload)
    }

    fetchToolboxTemplateContent(toolboxURI, templateId) {
        return axios.get(`${toolboxURI}/patern/${templateId}`, {
            transformRequest(data, headers) {
                if (headers && headers.common && headers.common.Authorization) {
                    delete headers.common.Authorization
                }
                return data
            },
            headers: {
                user: JSON.stringify({
                    name: 'test',
                    email: 'test',
                    production: true
                })
            }
        })
    }

    printZPL(payload) {
        return axios.post('/sendings/print-existing-label', payload)
    }
}

export default new EcommerceOrdersQueries()
